export const Logo = () => {
    return (
        <div className="flex justify-center items-center bg-white p-4 rounded-t-md">
            <img
                src={'/images/bank_logo/cortal-consors_Logo.png'}
                alt="consors bank logo"
                className="w-[125px] min-w-[125px]"
            />
        </div>
    );
};
